import { render } from "./RulesByAmount.vue?vue&type=template&id=6ccf1050"
import script from "./RulesByAmount.vue?vue&type=script&lang=js"
export * from "./RulesByAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__